import { IconContent } from '@icons';

export const businessCenterFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M5 2a1 1 0 0 0-1 1v18H2v1h20v-1h-2V3a1 1 0 0 0-1-1H5Zm4 3H7v2h2V5Zm4 0h-2v2h2V5Zm2 0h2v2h-2V5ZM9 8H7v2h2V8Zm2 0h2v2h-2V8Zm6 0h-2v2h2V8ZM7 11h2v2H7v-2Zm6 0h-2v2h2v-2Zm2 0h2v2h-2v-2Zm-6 3H7v2h2v-2Zm2 0h2v2h-2v-2Zm6 0h-2v2h2v-2Zm-6 5h2v2h-2v-2Z" />',
};
